var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EmbedYoutubeVideo',{attrs:{"id":_vm.videoIntroId,"size":{ width: 860, height: 480 },"zoom":false,"dark":""}})}
var staticRenderFns = []

export { render, staticRenderFns }